import { createApp } from 'vue'

import { createPinia } from 'pinia';
import AnalyticsChart from '@views/DashboardWidget.vue'
(() => {
    const app = createApp(AnalyticsChart)

    app.use(createPinia())

    app.mount('#wp-dark-mode-dashboard-widget')
})()
